import script from "./CoreProgramQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreProgramQuestions.vue?vue&type=script&setup=true&lang=js"

import "./CoreProgramQuestions.vue?vue&type=style&index=0&id=79dcc319&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79dcc319"]])

export default __exports__